import Vue from 'vue'
import Vuex from 'vuex'

import { getListIds } from '@/utils/dev'

import events from './events'
import library from './library'
import users from './users'
import support from './support'
import polls from './polls'
import { chat } from './chat'
import feedback from '@/store/feedback'
import notifications from '@/store/notifications'
import folders from '@/store/folders'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentTime: Date.now(),
    modal: false,
    modalOptions: null,
    menu: false,
    typesEvent: [
      ...getListIds('General course', 'Special course', 'Guest lecture', 'Social event'),
      {
        id: -1,
        title: 'Open hours',
      },
      {
        id: 5,
        title: 'Other',
      },
    ],
  },
  mutations: {
    openMenu(s) {
      s.menu = true
    },
    closeMenu(s) {
      s.menu = false
    },
    updateTime(s) {
      s.currentTime = Date.now()
    },
    closeModal(s) {
      s.modal = false
      s.modalOptions = null
    },
    openModal(s, payload) {
      if (!payload.options) {
        s.modal = payload
        s.modalOptions = null
      } else {
        s.modal = payload.name
        s.modalOptions = payload.options
      }
    },
  },
  actions: {},
  modules: {
    events,
    library,
    users,
    support,
    polls,
    chat,
    feedback,
    notifications,
    folders,
  },
})
